import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
export default function StyleContext(_ref) {
  var children = _ref.children,
      context = _ref.context;
  var createTheme = useCallback(parentTheme => {
    if (!context) {
      return parentTheme;
    }

    var newContext = _objectSpread({}, parentTheme.context);

    var hasChanged = false;

    if (Array.isArray(context)) {
      context.forEach(name => {
        if (!newContext[name]) {
          newContext[name] = true;
          hasChanged = true;
        }
      });
    } else if (typeof context === 'object') {
      Object.keys(context).forEach(name => {
        var value = context[name];

        if (newContext[name] !== value) {
          newContext[name] = value;
          hasChanged = true;
        }
      });
    } else if (!newContext[context]) {
      newContext[context] = true;
      hasChanged = true;
    }

    if (!hasChanged) {
      return parentTheme;
    }

    return _objectSpread(_objectSpread({}, parentTheme), {}, {
      context: newContext
    });
  }, [context]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createTheme
  }, children);
}
StyleContext.propTypes = {
  children: PropTypes.node,
  context: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.object]).isRequired
};